import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    marginVertical: 20,
  },
  label: {
    marginBottom: 10,
  },
  value: {
    flexDirection: 'row',
  },
});
